import { render, staticRenderFns } from "./FcDuration.vue?vue&type=template&id=2edd079e&scoped=true&"
import script from "./FcDuration.vue?vue&type=script&lang=js&"
export * from "./FcDuration.vue?vue&type=script&lang=js&"
import style0 from "./FcDuration.vue?vue&type=style&index=0&id=2edd079e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edd079e",
  null
  
)

export default component.exports